import {
  RFID_ENDORSEMENTS_FAIL,
  RFID_ENDORSEMENTS_REQUEST,
  RFID_ENDORSEMENTS_SUCCESS,
  RFID_ENDORSEMENT_APPROVE_FAIL,
  RFID_ENDORSEMENT_APPROVE_REQUEST,
  RFID_ENDORSEMENT_APPROVE_SUCCESS,
} from "../constants/RfidEndorsementConstants";
import RfidEndorsementService from "../service/RfidEndorsementService";

const getErrorMessage = (error) =>
  error.response?.data?.message || error.message || "Request failed.";

export const getRfidEndorsements = () => async (dispatch) => {
  dispatch({ type: RFID_ENDORSEMENTS_REQUEST });

  try {
    const [cdlResponse, subResponse] = await Promise.all([
      RfidEndorsementService.getCdlEndorsements(),
      RfidEndorsementService.getSubEndorsements(),
    ]);

    dispatch({
      type: RFID_ENDORSEMENTS_SUCCESS,
      payload: {
        cdl: cdlResponse.data?.ResultSet || [],
        subcontract: subResponse.data?.ResultSet || [],
      },
    });
  } catch (error) {
    dispatch({
      type: RFID_ENDORSEMENTS_FAIL,
      payload: { error: getErrorMessage(error) },
    });
    throw error;
  }
};

export const approveRfidEndorsement = (kind, row, status = "I") => async (dispatch) => {
  dispatch({ type: RFID_ENDORSEMENT_APPROVE_REQUEST });

  try {
    if (kind === "cdl") {
      await RfidEndorsementService.updateCdlEndorsement(row, status);
    } else {
      await RfidEndorsementService.updateSubEndorsement(row, status);
    }

    dispatch({
      type: RFID_ENDORSEMENT_APPROVE_SUCCESS,
      payload: {
        kind,
        id: kind === "cdl" ? row.HBL_ID : row.TFT_UID,
        date: row.TFT_DATETIME,
      },
    });
  } catch (error) {
    dispatch({
      type: RFID_ENDORSEMENT_APPROVE_FAIL,
      payload: { error: getErrorMessage(error) },
    });
    throw error;
  }
};